import { message } from 'antd';

export const syncErrorReason = error => {
  const data = error.response && error.response.data;
  return (data && (data.debugMessage || data.message)) || error.message || 'unknown error';
};

export const showSyncResult = result => {
  const counts = result.added.length + ' added, ' + result.updated + ' updated';
  if (result.status === 'PARTIAL') {
    message.warning(
      'Sync finished with issues: ' +
        counts +
        ', ' +
        result.skipped.length +
        ' skipped, ' +
        result.conflicts.length +
        ' major/minor conflict(s).',
      10,
    );
  } else {
    message.success('Sync complete: ' + counts + '.');
  }
};
